import { render, staticRenderFns } from "./LicenseOpenId.vue?vue&type=template&id=5a810127&scoped=true&"
import script from "./LicenseOpenId.vue?vue&type=script&lang=js&"
export * from "./LicenseOpenId.vue?vue&type=script&lang=js&"
import style0 from "./LicenseOpenId.vue?vue&type=style&index=0&id=5a810127&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a810127",
  null
  
)

export default component.exports